export const NAME = "customers" as const;
export const ALL_SPECIAL_PRICES_FORM_MODAL = "ALL_SPECIAL_PRICES_FORM";

export const defaultCustomersTableConfig = { pageSize: 10, pageIndex: 0, filters: {} };
